/*
 * � 2020 Microsoft. All rights reserved.
 */

define('CardUI/PileView',['lodash', 'pixi', 'CardUI/KeyboardNavigator', 'Arkadium/GameEngine/Scenes/Nodes/SpriteNode', 'CardUI/CardView', 'CardUI/CardHint',
    'Arkadium/GameEngine/Core/EngineManagers', 'Arkadium/GameEngine/Maths/Vector2', 'absolute'],
    function (_, PIXI, KeyboardNavigator, SpriteNode, CardView, CardHint, EngineManagers, Vector2, Absolute) {

        var PileView = function (pile, supplyView) {
            this.initPileView(pile, supplyView);
        };

        PileView.prototype.constructor = PileView;
        PileView.prototype = Object.create(SpriteNode.prototype);

        PileView.MinPileSpacing = 0.05;

        // An optional setting to force the pile view to display a certain pile display type.
        // If unset (Default), decides what to display based on the name of its Pile.
        PileView.Display = { Default: 0, Blank: 1, Circle: 2, Foundation: 3, X: 4, Tableau: 5, Stock: 6, Club: 7, Heart: 8, Diamond: 9, Spade: 10 };

        Object.defineProperty(PileView.prototype, "DisplayType",
            {
                set: function (value) {
                    if (value != this._displayType) {
                        this._displayType = value;

                        switch (value) {
                            case PileView.Display.Blank:
                                this.Background.SetTexture(this.SupplyView.GetThemeAssetPath("blankpile"));
                                break;
                            case PileView.Display.Circle:
                                this.Background.SetTexture(this.SupplyView.GetThemeAssetPath("emptypile_circle"));
                                break;
                            case PileView.Display.Tableau:
                            case PileView.Display.Stock:
                                this.Background.SetTexture(this.SupplyView.GetThemeAssetPath("emptypile"));
                                break;
                            case PileView.Display.X:
                                this.Background.SetTexture(this.SupplyView.GetThemeAssetPath("emptypile_x"));
                                break;
                            case PileView.Display.Club:
                                this.Background.SetTexture(this.SupplyView.GetThemeAssetPath("foundation_club"));
                                break;
                            case PileView.Display.Heart:
                                this.Background.SetTexture(this.SupplyView.GetThemeAssetPath("foundation_heart"));
                                break;
                            case PileView.Display.Diamond:
                                this.Background.SetTexture(this.SupplyView.GetThemeAssetPath("foundation_diamond"));
                                break;
                            case PileView.Display.Spade:
                                this.Background.SetTexture(this.SupplyView.GetThemeAssetPath("foundation_spade"));
                                break;
                        }
                        //this.Background.BlendMode = BlendMode.MaximumAlpha;
                        //this.Background.TextureAlphaEnabled = true;
                        //this.Background.Layer = -1;
                    }
                },
                get: function () {
                    return this._displayType;
                }
            });

        PileView.Facing = { FaceUp: 0, FaceDown: 1, Hidden: 2 };

        PileView.Layout = { Pile: 0, FanDown: 1, FanRight: 2 };

        PileView.Interaction = { None: 0, Click: 1, Drag: 2 };

        Object.defineProperty(PileView.prototype, "StackedPile",
            {
                get: function () {
                    return this._stackedPile;
                },
                set: function (value) {
                    this._stackedPile = value;
                    value.PileStackedOn = this;
                }
            });

        Object.defineProperty(PileView.prototype, "DefaultPileSpacing",
            {
                get: function () {
                    return this._defaultPileSpacing;
                },
                set: function (value) {
                    this._defaultPileSpacing = value;
                    this.PileSpacing = this.BlockedPileSpacing = this.AfterShufflePileSpacing = value;
                }
            });

        Object.defineProperty(PileView.prototype, "IsHinted",
            {
                get: function () {
                    return this._isHinted;
                },
                set: function (value) {
                    if (this._hintTexture == null || value == this._isHinted)
                        return;
                    this._isHinted = value;
                    if (this._isHinted && this.SupplyView.EnablePileHints) {
                        this._hintTexture.visible = true;
                        this._hintTexture.AnimatePulse();
                    }
                    else {
                        this._hintTexture.visible = false;
                        this._hintTexture.StopPulse();
                    }
                }
            });

        PileView.prototype.dealIsNotAllowed = function () {
            this._hintTexture.visible = true;
            this._hintTexture.AnimatePulseOnce();
        }

        PileView.prototype.initPileView = function (pile, supplyView) {
            SpriteNode.call(this);

            this.Pile = pile;
            this.SupplyView = supplyView;
            this.FanFraction = 1;

            this.Background = new SpriteNode();
            this.OnMouseDownEventHandler = this.OnMouseDownEvent.bind(this);
            this.Background.PointDown.add(this.OnMouseDownEventHandler);
            this.Background.interactive = true;
            this.PointDown.add(this.OnMouseDownEventHandler);
            this.interactive = true;

            this.SupplyView.CardScaleChanged.add(this.SupplyViewCardScaleChanged.bind(this));
            //((ITexturedMaterialImplementation)Background.Material).Sampler.Smoothing = GameEngine.Rendering.TextureSamplerSmoothingMode.Bilinear;
            //Background.TextureAlphaEnabled = true;
            this.SupplyView.pileBackgroundContainer.addChildAt(this.Background, 0);

            this.Keyboard = new KeyboardNavigator(this);
            this.KeyboardMode = PileView.KeyboardModes.NoKeyboard;

            this._displayType = PileView.Display.Default;
            this.CardFacing = PileView.Facing.FaceDown;
            this.PileMode = PileView.Layout.Pile;
            this.InteractionMode = PileView.Interaction.None;
            this.FanLimit = 0;
            this.NumFanning = 0;
            /// <summary>
            /// Show one card fanned for every <i>FanFraction</i> cards.
            /// </summary>

            this._stackedPile = null;
            this.PileStackedOn = null;

            this.LogicalScreenPos = new PIXI.Point();

            this.PileSpacing = new Vector2();
            this.BlockedPileSpacing = new Vector2();
            this._defaultPileSpacing = new Vector2();
            this.AfterShufflePileSpacing = new Vector2();
            this.HeightLimit = 0;
            this.AllowClickWhenEmpty = true;

            this._keyboardHighlightTexture = null
            this._hintTexture = null;

            this._isHinted = false;

            this.FullyCompressOnDeal = false;

            this.KeyboardMode = PileView.KeyboardModes.NoKeyboard;

            this.FocusedCard = null;

            this.LogicalScreenPos = new PIXI.Point(0, 0);

            this.InputEnabled = true;
            this.buttonMode = true;

            this.Init(null);
        };


        PileView.prototype.SupplyViewCardScaleChanged = function (sender, e) {
            this.UpdateBackgroundScale();
            this.UpdateHintScale();
        };


        PileView.prototype.UnregisterEvents = function ()
        {
            this.Background.PointDown.remove(this.OnMouseDownEventHandler);
            this.SupplyView.CardScaleChanged.remove(this.SupplyViewCardScaleChanged.bind(this));
            this.Keyboard.ResetKeypressHandlers();
            _.forEach(this.children, function (child) {
                if (child instanceof CardView) {
                    child.UnregisterEvents();
                }
            });
        }
        ;


        PileView.prototype.Init = function (callback) {
            this._keyboardHighlightTexture = new SpriteNode();
            this._keyboardHighlightTexture.SetTexture(this.SupplyView.GetThemeAssetPath("keyboard_highlight"));
            this._keyboardHighlightTexture.TextureAlphaEnabled = true;
            //((ITexturedMaterialImplementation)_keyboardHighlightTexture.Material).Sampler.Smoothing = GameEngine.Rendering.TextureSamplerSmoothingMode.Bilinear;
            this._keyboardHighlightTexture.Init(null);
            this._keyboardHighlightTexture.InputEnabled = false;
            this._keyboardHighlightTexture.Visible = false;
            this._keyboardHighlightTexture.Layer = 1;
            this._keyboardHighlightTexture.Position = this.Position;
            this._keyboardHighlightTexture.sprite.anchor.x = this._keyboardHighlightTexture.sprite.anchor.y = 0.5;
           this.AddChild(this._keyboardHighlightTexture);


            this._hintTexture = new CardHint(this.SupplyView.GetThemeAssetPath(CardHint.TexturePath));
            this.AddChild(this._hintTexture);
            this._hintTexture.Visible = false;
            this._hintTexture.ScaleX = this._hintTexture.ScaleY = this.SupplyView.CardScale * CardView.ScaleFactor * CardView.HintScale;
            SpriteNode.prototype.Init.call(this, callback);
        };

        PileView.prototype.OnMouseDownEvent = function (sender, pointEvent) {
            if (this.SupplyView.KeyboardFocus != null)
                this.SupplyView.KeyboardFocus.Keyboard.LoseKeyboardFocus();

            if (this.SupplyView.IsCardDragging)
                return;

            if (this.Pile.Empty) {
                this.SupplyView.TellMouseDown(this);
            }
        };

        PileView.prototype.UpdateInternal = function (time) {

            if (this.SupplyView.KeyboardFocus == this) {
                if (this.FocusedCard != null && this.FocusedCard.Card.Pile != this.Pile) {
                    this.FocusedCard = this.Pile.Empty ? null : this.SupplyView.GetCardView(this.Pile.Top);
                }
                else if (this.FocusedCard == null && !this.Pile.Empty) {
                    this.FocusedCard = this.SupplyView.GetCardView(this.Pile.Top);
                }
            }
            if (this._keyboardHighlightTexture != null) {
                if (this.SupplyView.KeyboardFocus == this &&
                    this.FocusedCard == null &&
                    this.SupplyView.Focused &&
                    this.AllowClickWhenEmpty &&
                    this.Keyboard.HasKeyboardFocus) {
                        if (!this._keyboardHighlightTexture.Visible)
                            this._keyboardHighlightTexture.Visible = true;
                        if (Math.abs(this._keyboardHighlightTexture.ScaleX - this.SupplyView.CardScale) > 0.000001)
                            this._keyboardHighlightTexture.ScaleX = this._keyboardHighlightTexture.ScaleY = this.SupplyView.CardScale;
                }
                else {
                    if (this._keyboardHighlightTexture.Visible)
                        this._keyboardHighlightTexture.Visible = false;
                }
            }
            SpriteNode.prototype.UpdateInternal.call(this, time);

            if (this.FanLimit > 0) {
                this.NumFanning = this.FanLimit;
            }

            if (this.CardFacing == PileView.Facing.Hidden)
                return;

            if (this.AllowClickWhenEmpty) {
                // Piles only accept input if they have no cards
                if (this.Pile.Count == 0 && this.InteractionMode != PileView.Interaction.None) {
                    this.Background.InputEnabled = true;
                    this.Background.buttonMode = true;
                    this.buttonMode = true;
                }
                else {
                    this.Background.InputEnabled = false;
                    this.Background.buttonMode = false;
                    this.buttonMode = false;
                }
            } else {
                this.Background.InputEnabled = false;
                this.Background.buttonMode = false;
                this.interactive = false;
                this.buttonMode = false;
            }

            this.Compress();
            this.UpdatePosition();
        };

        PileView.prototype.UpdateHintScale = function () {
            if (this._hintTexture != null) {
                if (Math.abs(this._hintTexture.ScaleX - this.SupplyView.CardScale) > 0) {
                    this._hintTexture.ScaleX = this._hintTexture.ScaleY = this.SupplyView.CardScale * CardView.ScaleFactor * CardView.HintScale;
                    if (Absolute.Platform.isMobile()) {
                        this._hintTexture.ScaleY = CardView.ScaleFactor * 2.9;
                    }
                }
            }
        };

        PileView.prototype.UpdateBackgroundScale = function () {
            if (this.Background != null && this.Background.IsLoaded) {
                // TODO - evalate the need for this hack
                // HACK The size of the blank pile PNG still has the old smaller card size dimensions.
                //      Replace the asset with its proper size and remove this hack.
                if (this._displayType != PileView.Display.Blank)
                    this.Background.ScaleUniform = this.SupplyView.CardScale * CardView.ScaleFactor * 2;
                else
                    this.Background.ScaleUniform = this.SupplyView.CardScale;
            }
        };

        PileView.prototype.UpdatePosition = function () {
            this.X = (this.SupplyView.GetWidth() * this.LogicalScreenPos.x);
            this.Y = (this.SupplyView.GetHeight() * this.LogicalScreenPos.y);
            this.Background.X = (this.SupplyView.GetWidth() * this.LogicalScreenPos.x);
            this.Background.Y = (this.SupplyView.GetHeight() * this.LogicalScreenPos.y);

        };

        PileView.prototype.GetScreenPosition = function () {
            var xPos = (this.SupplyView.GetWidth() * this.LogicalScreenPos.x);
            var yPos = (this.SupplyView.GetHeight() * this.LogicalScreenPos.y);
            var pos = this.Parent.toGlobal(new PIXI.Point(xPos, yPos));
            return new PIXI.Point(pos.x, pos.y);
        };

        PileView.prototype.BottomRightCornerGlobal = function (card) {
            var pixiPoint = card.toGlobal(new PIXI.Point(card.width / 2, card.height / 2));

            return new Vector2(pixiPoint.x,pixiPoint.y);
            //return card.toGlobal(new PIXI.Point(card.width / 2, card.height / 2));
            //return card.toGlobal(new Vector2(card.width / 2, card.height / 2));

        };

        PileView.prototype.Compress = function () {

            if (this.SupplyView.CardSupply.WaitingForAnimation || Math.abs(this.HeightLimit) < 0.000001 || this.Pile.Count == 0)
                return;

            var top = this.SupplyView.GetCardView(this.Pile.Top);

            // Ignore cards being interacted with.
            if (top.IsPickedUp)
                return;

            var pileShrinkFactor = 0.9;
            var pileGrowthFactorNormal = 1.1;
            var pileGrowthFactorStock = 1.6; // stock piles grow out right away

            var pileGrowthFactor = (this.Pile.Type == "Stock") ? pileGrowthFactorStock : pileGrowthFactorNormal;

            // Only enable blocked spacing in Spider and FreeCell
            var blockedPileSpacingAllowed = this.SupplyView.CardSupply.GameName == "Spider" || this.SupplyView.CardSupply.GameName == "FreeCell";
            var bottomRightGlobal = this.BottomRightCornerGlobal(top);
            var heightLimit = EngineManagers.Display.Height * this.HeightLimit;

            /// Klondike Only. foregoing all animated compression nonsense that is full of bugs and super extra confusing
            if(this.SupplyView.CardSupply.GameName == "Klondike" ) {

                var cardsSpace = this.worldTransform.ty + ((this.Pile.Count - 1) * 0.24) + top._cachedHeight / 2;
                var availableHeight = Math.abs(heightLimit - cardsSpace); // hack the available height off a bit for padding?
                var availableSpace = availableHeight / this.Pile.Cards.length;
                var percentageOfCardHeight = availableSpace / (top._cachedHeight * top.scale.y);
                if(this.PileSpacing.Y == percentageOfCardHeight || percentageOfCardHeight > this.DefaultPileSpacing.Y) {
                    return;
                }
                this.BlockedPileSpacing = this.PileSpacing = new Vector2(this.PileSpacing.X, percentageOfCardHeight);
                return; // because the rest of the stuff in this method is for other games not klondike
            }
            // end klondike only stuff

            if (bottomRightGlobal.Y > heightLimit)
            {
                // 0. Shrink the stacked pile spacing, if any.
                if (this.StackedPile != null && this.StackedPile.PileSpacing.Length > PileView.MinPileSpacing)
                {
                    this.StackedPile.PileSpacing = new Vector2(this.StackedPile.PileSpacing.X, this.StackedPile.PileSpacing.Y * pileShrinkFactor);
                }
                // 1. Shrink blocked pile spacing (Spider and FreeCell only).
                else if (blockedPileSpacingAllowed && this.BlockedPileSpacing.Length > PileView.MinPileSpacing)
                {
                    this.BlockedPileSpacing = new Vector2(this.BlockedPileSpacing.X, this.BlockedPileSpacing.Y * pileShrinkFactor);
                }
                // 2. Shrink pile spacing.
                else
                {
                    // this.PileSpacing is use nowhere for card spacing in klondike in particular where it is needed.
                    this.PileSpacing = new Vector2(this.PileSpacing.X, this.PileSpacing.Y * pileShrinkFactor);
                }
            }
            else
            {
                // 0. Grow pile spacing. // DAN - Maybe shouldn't be "Length"?
                if (this.PileSpacing.Length < this.DefaultPileSpacing.Length * pileShrinkFactor) // Don't grow pile spacing if it'll put us over our default spacing.
                {
                    this.savedPileSpacing = this.PileSpacing;

                    // Grow pile spacing until the next adjustment puts the top card over the height limit.
                    this.PileSpacing = new Vector2(this.PileSpacing.X * pileGrowthFactor, this.PileSpacing.Y * pileGrowthFactor);
                    if (this.PileSpacing.LengthSquared > this.DefaultPileSpacing.LengthSquared) {
                        this.PileSpacing = this.DefaultPileSpacing;
                    }

                    this.UpdateChildPositions();

                    bottomRightGlobal = this.BottomRightCornerGlobal(top);
                    if (bottomRightGlobal.Y > heightLimit)
                    {
                        this.PileSpacing = this.savedPileSpacing; // Undo the adjustment if we go over.
                    }
                }
                // 1. Grow blocked pile spacing (Spider only).
                else if (blockedPileSpacingAllowed && this.BlockedPileSpacing.Length <this. DefaultPileSpacing.Length * pileShrinkFactor)
                {
                    this.savedPileSpacing = this.BlockedPileSpacing;

                    this.BlockedPileSpacing = new Vector2(this.BlockedPileSpacing.X * pileGrowthFactor, this.BlockedPileSpacing.Y * pileGrowthFactor);
                    if (this.BlockedPileSpacing.LengthSquared > this.DefaultPileSpacing.LengthSquared) {
                        this.BlockedPileSpacing = this.DefaultPileSpacing;
                    }

                    this.UpdateChildPositions();

                    bottomRightGlobal = this.BottomRightCornerGlobal(top);
                    if (bottomRightGlobal.Y > heightLimit) {
                        this.BlockedPileSpacing = this.savedPileSpacing;
                    }
                }
                // 2. Grow the stacked pile spacing, if any.
                else if (this.StackedPile != null &&
                    this.StackedPile.PileSpacing.Length < this.StackedPile.DefaultPileSpacing.Length * pileShrinkFactor)
                {
                    this.savedPileSpacing = this.StackedPile.PileSpacing;

                    this.StackedPile.PileSpacing = new Vector2(this.StackedPile.PileSpacing.X * pileGrowthFactor, this.StackedPile.PileSpacing.Y * pileGrowthFactor);
                    if (this.StackedPile.PileSpacing.LengthSquared > this.DefaultPileSpacing.LengthSquared) {
                        this.StackedPile.PileSpacing = this.DefaultPileSpacing;
                    }

                    this.StackedPile.UpdateChildPositions();
                    this.UpdateChildPositions();

                    bottomRightGlobal = this.BottomRightCornerGlobal(top);
                    if (bottomRightGlobal.Y > heightLimit)
                    {
                        this.StackedPile.PileSpacing = this.savedPileSpacing;
                        this.StackedPile.UpdateChildPositions(); // Revert the stacked pile positions (which probably already went through its Update() this cycle).
                    }
                }
            }

        };

        PileView.prototype.NotifyDealing = function () {
            if (this.FullyCompressOnDeal) {
                this.PileSpacing = new Vector2(this.PileSpacing.x * 0.01, this.PileSpacing.y * 0.01);
                this.BlockedPileSpacing = new Vector2(this.BlockedPileSpacing.x * 0.01, this.BlockedPileSpacing.y * 0.01);
                this.UpdateChildPositions();
            }
        };

        PileView.prototype.UpdateChildPositions = function () {
            _.forEach(this.children, function (child) {
                if (child instanceof CardView) {
                    child.UpdatePosition();
                }
            });

        };

        PileView.KeyboardModes = {
            NoKeyboard: 0,
            TopCard: 1,
            TopCardAndEmpty: 2,
            TopCardIfAllowed: 3,
            AllCards: 4,
            AllCardsAndEmpty: 5
        };

        PileView.prototype.OnGetKeyboardFocus = function () {
            if (this.KeyboardMode == PileView.KeyboardModes.NoKeyboard) {
                return false;
            }
            if (this.Pile.Count != 0) {
                if (this.KeyboardMode == PileView.KeyboardModes.TopCardIfAllowed && !this.SupplyView.CardSupply.Authority.CanKeyboardFocusCard(this.Pile.Top)) {
                    // can't pick up this card, return false.
                    return false;
                }
                this.FocusedCard = this.SupplyView.GetCardView(this.Pile.Top);
            }
            else {
                if (this.KeyboardMode == PileView.KeyboardModes.AllCardsAndEmpty ||
                    this.KeyboardMode == PileView.KeyboardModes.TopCardAndEmpty) {
                    this.FocusedCard = null; // no card to focus on
                }
                else {
                    return false;
                }
            }
            // take focus!
            return true;
        };

        /// <summary>
        /// Give up keyboard focus.
        /// </summary>
        PileView.prototype.OnLoseKeyboardFocus = function () {
            // give up focus
            this.FocusedCard = null;
        };

        /// <summary>
        /// Handle the keyprses and return true, or don't handle it and return false.
        /// </summary>
        /// <param name="key"></param>
        /// <returns></returns>
        PileView.prototype.TryHandleKeypress = function (key) {
            if (key == KeyboardNavigator.KeyPress.Activate) {
                if (this.FocusedCard != null) {
                    this.SupplyView.TellMouseDown(this.FocusedCard, false);
                }
                else {
                    this.SupplyView.TellMouseDown(this);
                }
                return false;
            }
            if (key == KeyboardNavigator.KeyPress.Tab || key == KeyboardNavigator.KeyPress.ShiftTab) {
                return false;
            }
            if (key == KeyboardNavigator.KeyPress.Up || key == KeyboardNavigator.KeyPress.Down || key == KeyboardNavigator.KeyPress.Left || key == KeyboardNavigator.KeyPress.Right) {
                if (this.KeyboardMode == PileView.KeyboardModes.TopCard || this.KeyboardMode == PileView.KeyboardModes.TopCardAndEmpty ||
                    this.FocusedCard == null) {
                    return false;
                }
                var handled = false; // whether we handled the keypress, or if we need to call ProcessKeyActions
                if ((key == KeyboardNavigator.KeyPress.Up && this.FocusedCard.Card != this.Pile.Bottom && this.PileMode == PileView.Layout.FanDown) ||
                    (key == KeyboardNavigator.KeyPress.Left && this.FocusedCard.Card != this.Pile.Bottom && this.PileMode == PileView.Layout.FanRight)) {
                    // previous card!
                    var pos = this.Pile.GetCardPosFromEnd(this.FocusedCard.Card);
                    var nextCard = this.Pile.NthFromTop(pos + 1);
                    if (nextCard != null) {
                        // move up a card
                        this.FocusedCard = this.SupplyView.GetCardView(nextCard);
                        handled = true;
                    }
                }
                else if ((key == KeyboardNavigator.KeyPress.Down && this.FocusedCard.Card != this.Pile.Top && this.PileMode == PileView.Layout.FanDown) ||
                    (key == KeyboardNavigator.KeyPress.Right && this.FocusedCard.Card != this.Pile.Top && this.PileMode == PileView.Layout.FanRight)) {
                    // next card!
                    var pos = this.Pile.GetCardPosFromEnd(this.FocusedCard.Card);
                    var nextCard = this.Pile.NthFromTop(pos - 1);
                    if (nextCard != null) {
                        // move up a card
                        this.FocusedCard = this.SupplyView.GetCardView(nextCard);
                        handled = true;
                    }
                }

                return handled;
            }
            return false;
        };

        return PileView;
    });


